import React, { useEffect, useState } from 'react';
import './sec1.css'
import CTA from '../components/common/cta';
import pic3 from '../assets/pic3.png'
import pic4 from '../assets/pic4.png'
import { useTranslation } from 'react-i18next';



const Sec1 = () => {

const { t, i18n } = useTranslation();
const direction = i18n.language === 'ar' ? 'rtl' : 'ltr';

const [animate, setAnimate] = useState(false);
useEffect(() => {
    const timer = setTimeout(() => {
        setAnimate(true);
    }, 350);

    return () => clearTimeout(timer);
}, []);


    return ( 
        <section className='sec1' dir={direction}>
            <article className='container2-text-sec1'>
                <article className='container-text-sec1'>
                    <h1 className='header-sec1'>  {t('Feel the')}
                       <span className={`highlight ${animate ? 'animate' : ''}`}>{t('Beat,')} </span> {t('Book the')}
                        <span className={`highlight ${animate ? 'animate' : ''}`} >{t('Seat')}</span></h1>
                    <p className='para-sec1'>{t('Discover live music events and book your seat in seconds.')}</p>
                    <CTA title={t('View Events')} s='cta-sec1'  />
                </article>
            </article>
            <div className='blurycircle'></div>
            <div className='small-blurycircle'></div>
            <img src={pic3} alt='pic' className={`img-sec1 ${animate ? 'animate' : ''}`}></img>
            <img src={pic4} alt='pic' className='img2-sec1'></img>
        </section>
     );
}
 
export default Sec1;